import { useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';

import handleEvent from 'utilities/handleEvent';
import { CONTACT_AN_AGENT_ROUTE } from 'utilities/routes';
import { CONTACT_CALLBACK_KEY } from 'utilities/storageKeys';

import styles from './styles.module.scss';

import { set } from 'temp/utilities/storage';

const FooterListItem = ({
    className = '',
    externalURL = false,
    lines1Text = '',
    lines2Text = '',
    link,
    onClick,
    text,
    twoLines = false
}) => {
    const history = useHistory();
    const handleClick = onClick => handleEvent(onClick);

    const renderTwoLines = useMemo(() => {
        return (
            <>
                <a
                    className={`${styles.link} ${styles.linkBlock}`}
                    href={link}
                    rel="noreferrer"
                    target="_blank"
                >
                    {lines1Text}
                </a>
                <a
                    className={`${styles.link} ${styles.linkBlock}`}
                    href={link}
                    rel="noreferrer"
                    target="_blank"
                >
                    {lines2Text}
                </a>
            </>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderExternalURLComponent = () => {
        if (twoLines) {
            return renderTwoLines;
        }

        return (
            <a className={styles.link} href={link} rel="noreferrer">
                {text}
            </a>
        );
    };

    return (
        <li className={`${styles.footerListItem} ${className}`}>
            {link ? (
                externalURL ? (
                    renderExternalURLComponent()
                ) : (
                    <Link
                        className={styles.link}
                        data-click-type="link"
                        onClick={e => {
                            e.preventDefault();
                            handleClick(e);
                            if (link === CONTACT_AN_AGENT_ROUTE) {
                                set(CONTACT_CALLBACK_KEY, 'true');
                                setTimeout(() => {
                                    history.push(link);
                                }, 300);
                            } else history.push(link);
                        }}
                        to={link}
                    >
                        {text}
                    </Link>
                )
            ) : (
                text
            )}
        </li>
    );
};

export default FooterListItem;
